/**
 * SectionEyebrow — padrão tipográfico editorial puro.
 * Sem qualquer elemento decorativo linear.
 *   [serif italic number] + [uppercase tracked label]
 */
export const SectionEyebrow = ({ children, num, tone = "default", align = "left" }) => {
  const numColor = "text-[#A7CA99]";
  const labelColor = tone === "muted" ? "text-[#A7CA99]" : "text-[#3E5239]";
  const justify = align === "center" ? "justify-center" : "";

  return (
    <div className={`flex items-baseline gap-4 mb-6 ${justify}`}>
      {num && (
        <span className={`font-serif text-lg italic font-light leading-none tracking-tight ${numColor}`}>
          {num}
        </span>
      )}
      <span className={`text-[11px] uppercase tracking-[0.32em] font-semibold ${labelColor}`}>
        {children}
      </span>
    </div>
  );
};
